import { useFeedConsumptionChartAll } from 'components/farm-dashboard/components/widgets/feed-consumption/hook'
import { useWidgetPreview } from '../context/WidgetPreviewContext'
import { FEED_CONSUMPTION_CHART_MOCK } from '../mocks/feedConsumptionChartMock'

export interface UseWidgetFeedConsumptionChartAllParams {
	startDate: number
	endDate: number
}

export function useWidgetFeedConsumptionChartAll({
	startDate,
	endDate,
}: UseWidgetFeedConsumptionChartAllParams) {
	const { isPreview } = useWidgetPreview()
	const real = useFeedConsumptionChartAll({
		startDate,
		endDate,
		enabled: !isPreview,
	})

	if (isPreview) {
		return {
			fetchData: FEED_CONSUMPTION_CHART_MOCK.fetchData,
			distributedFood: FEED_CONSUMPTION_CHART_MOCK.distributedFood,
			consumptionFood: FEED_CONSUMPTION_CHART_MOCK.consumptionFood,
			isLoading: false,
			isError: false,
			error: undefined,
		}
	}

	return real
}
